import { formatDuration } from '@process-advisor/process-miner/api/methods/shared/formatDuration';
import { formatPercentage } from '@process-advisor/process-miner/api/methods/shared/formatPercentage';
import { formatDurationMinutes } from '@process-advisor/process-miner/api/methods/shared/formatDurationMinutes';
import { formatNumber } from '@process-advisor/process-miner/api/methods/shared/formatNumber';
import { formatCost } from '@process-advisor/process-miner/api/methods/shared/formatCost';
import { formatCostDecimal } from '@process-advisor/process-miner/api/methods/shared/formatCostDecimal';
import { resetFilters } from '@process-advisor/process-miner/api/methods/shared/resetFilters';
import { resetEventLog } from '@process-advisor/process-miner/api/methods/shared/resetEventLog';
import { rebuildPVDiagram } from '@process-advisor/process-miner/api/methods/shared/rebuildPVDiagram';
import { setActiveAction } from '@process-advisor/process-miner/api/methods/shared/setActiveAction'
import { updateMetricSettings} from '@process-advisor/process-miner/api/methods/shared/updateMetricSettings'
import { updateGauges } from '@process-advisor/process-miner/api/methods/shared/updateGauges';
import { updateDashboard } from '@process-advisor/process-miner/api/methods/shared/updateDashboard';
import { alertMessage } from '@process-advisor/process-miner/api/methods/shared/alertMessage';
import { showContextMenu, hideContextMenu } from '@process-advisor/process-miner/api/methods/shared/contextMenu';
import { displayVisualizer } from '@process-advisor/process-miner/api/methods/shared/displayVisualizer'
import { closeProcessMiner } from '@process-advisor/process-miner/api/methods/shared/closeProcessMiner'
import { updateTaskAttributes } from '@process-advisor/process-miner/api/methods/shared/updateTaskAttributes';
import { saveDiscoveryRulesGridState } from '@process-advisor/process-miner/api/methods/shared/saveDiscoveryRulesGridState';
import { saveCostsGridState } from '@process-advisor/process-miner/api/methods/shared/saveCostsGridState';
import { showSpinner } from '@process-advisor/process-miner/api/methods/shared/showSpinner';
import { hideSpinner } from '@process-advisor/process-miner/api/methods/shared/hideSpinner';
import { changeBackgroundColor} from '@process-advisor/process-miner/api/methods/shared/changeBackroundColor'
import {downloadDiagram} from '@process-advisor/process-miner/api/methods/shared/downloadDiagram'
import { updateAnalytic } from '@process-advisor/process-miner/api/methods/shared/updateAnalytic'
import { formatDecimal } from '@process-advisor/process-miner/api/methods/shared/formatDecimal';

export const sharedMethods = {
    formatNumber,
    formatDuration,
    rebuildPVDiagram,
    resetFilters,
    formatDurationMinutes,
    formatPercentage,
    showContextMenu,
    hideContextMenu,
    updateGauges,
    alertMessage,
    resetEventLog,
    closeProcessMiner,
    updateTaskAttributes,
    setActiveAction,
    updateMetricSettings,
    saveDiscoveryRulesGridState,
    showSpinner,
    hideSpinner,
    changeBackgroundColor,
    downloadDiagram,
    formatCost,
    formatCostDecimal,
    saveCostsGridState,
    updateAnalytic,
    formatDecimal,
    updateDashboard
};
